module.exports = __webpack_public_path__ + "static/media/bot.543b804a.svg";